export enum HoursMode {
  SelectedHours,
  AlwaysOpen,
  NoHoursAvailble,
  PermanentlyClosed
};
